import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import localStorageConstants from "src/app/constants/localStorage.constants";
import { checkTokenValidity } from "src/app/utils/backendEndpointCalls.util";

const ProtectedRoute: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const validate = async () => {
      const token: string | null = localStorage.getItem(
        localStorageConstants.TOKEN,
      );
      if (!token) {
        setIsAuthorized(false);
        localStorage.removeItem(localStorageConstants.ROLE);
        localStorage.removeItem(localStorageConstants.TOKEN);
        localStorage.removeItem(
          localStorageConstants.SEPARATE_PAGES_PREFERENCE,
        );
        localStorage.removeItem(localStorageConstants.SHARE_WITH_CHILDREN);
        localStorage.removeItem(localStorageConstants.FIRST_TIME_VISITING);
        setIsLoading(false);
        return;
      }
      try {
        const response = await checkTokenValidity();
        if (response.success && !response.isSuspended) {
          localStorage.setItem(localStorageConstants.ROLE, response.role);
          localStorage.setItem(
            localStorageConstants.SEPARATE_PAGES_PREFERENCE,
            response.preferences.separateSites,
          );
          localStorage.setItem(
            localStorageConstants.SHARE_WITH_CHILDREN,
            response.preferences.shareFilesWithChildren,
          );
          localStorage.setItem(
            localStorageConstants.FIRST_TIME_VISITING,
            response.isFirstTimeVisiting,
          );
          setIsAuthorized(true);
        } else {
          localStorage.removeItem(localStorageConstants.ROLE);
          localStorage.removeItem(localStorageConstants.TOKEN);
          localStorage.removeItem(
            localStorageConstants.SEPARATE_PAGES_PREFERENCE,
          );
          localStorage.removeItem(localStorageConstants.SHARE_WITH_CHILDREN);
          localStorage.removeItem(localStorageConstants.FIRST_TIME_VISITING);
          setIsAuthorized(false);
        }
      } catch (err) {
        localStorage.removeItem(localStorageConstants.ROLE);
        localStorage.removeItem(localStorageConstants.TOKEN);
        localStorage.removeItem(
          localStorageConstants.SEPARATE_PAGES_PREFERENCE,
        );
        localStorage.removeItem(localStorageConstants.SHARE_WITH_CHILDREN);
        localStorage.removeItem(localStorageConstants.FIRST_TIME_VISITING);
        setIsAuthorized(false);
      } finally {
        setIsLoading(false);
      }
    };
    validate();
  }, []);
  if (isLoading) return null;
  if (!isAuthorized) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default ProtectedRoute;
